import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  padding: 24px;
`

export const title: Interpolation<Theme> = css`
  font-weight: 700;
  margin-bottom: 24px;
`

export const link: Interpolation<Theme> = (theme: Theme) => css`
  color: ${theme.colors.blueHover};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(3, 0, 3)};
`
